import { Resource } from '../base/Resource';
import { RequestParameter } from '../Types';

export const getRequestInit = (
  resource: Resource<unknown, unknown>,
  requestParams?: RequestParameter[]
) => {
  const requestInit = resource.requestInitReslover(requestParams);
  return requestInit;
};